import { render } from "./CategoryTwelveDialog.vue?vue&type=template&id=ea16737c&scoped=true"
import script from "./CategoryTwelveDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryTwelveDialog.vue?vue&type=script&lang=ts"

import "./CategoryTwelveDialog.vue?vue&type=style&index=0&id=ea16737c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ea16737c"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
